import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {LatestModelStatus, LiveModelRequest} from '@core/interfaces/live/live';
import {Filter} from '@core/interfaces/system/system-common';
import {BatteryBankApi} from '@core/backend/engin/api/live/battery-bank.api';
import {
    BatteryBankCellMetricRequest,
    CellMetricTimeseriesChart,
    CellMetricAggregatedChart,
    BatteryBankCellStatusDto,
    BatteryBankMetricChartDto,
    BatteryBankModelMetricRequest,
    BatteryBankService,
    BatteryBankUnits,
    CellInfoDto,
    BatteryBankMetricSummary,
    BatteryBankChartTypes,
} from '@core/interfaces/live/battery-bank';
import {DownloadCSVUrl} from '@core/interfaces/engin/workflow-validation';

@Injectable()
export class BatteryBankServiceImpl extends BatteryBankService {
    constructor(private api: BatteryBankApi) {
        super();
    }

    // Generic
    public getDatasource(id: string, filters: Filter[]): Observable<DataSource> {
        return this.api.getDatasource(id, filters);
    }

    public getUnits(): Observable<BatteryBankUnits> {
        return this.api.getUnits();
    }

    public getCountResults(id: string, uploadDate?: string): Observable<number> {
        return this.api.getCountResults(id, uploadDate);
    }

    public getLatestStatusDetails(request: LiveModelRequest): Observable<LatestModelStatus> {
        return this.api.getLatestStatusDetails(request);
    }

    // Charts > Battery banks
    public getBatteryBankMetricsLatest(request: LiveModelRequest): Observable<BatteryBankMetricSummary> {
        return this.api.getBatteryBankMetricsLatest(request);
    }

    public getBatteryBankMetricByTime(request: BatteryBankModelMetricRequest): Observable<BatteryBankMetricChartDto> {
        return this.api.getBatteryBankMetricByTime(request);
    }

    // Charts > Cells
    public getCellsLatestStatus(request: LiveModelRequest): Observable<BatteryBankCellStatusDto> {
        return this.api.getCellsLatestStatus(request);
    }

    public getCellsLatestStatusCsv(request: LiveModelRequest): Observable<DownloadCSVUrl> {
        return this.api.getCellsLatestStatusCsv(request);
    }

    public getCellsAggregatedChart(
        request: LiveModelRequest,
        readingMetricType: BatteryBankChartTypes,
    ): Observable<CellMetricAggregatedChart> {
        return this.api.getCellsAggregatedChart(request, readingMetricType);
    }

    public getCellMetricChartByTime(request: BatteryBankCellMetricRequest): Observable<CellMetricTimeseriesChart> {
        return this.api.getCellMetricChartByTime(request);
    }

    // Cells
    public getCellOptions(request: LiveModelRequest): Observable<CellInfoDto[]> {
        return this.api.getCellOptions(request);
    }

    public getCellResultList(request: LiveModelRequest, filters: Filter[] = []): Observable<DataSource> {
        return this.api.getCellResultList(request, filters);
    }

    public getCellResultListCsv(
        request: LiveModelRequest,
        paramsString: string,
        filters: Filter[] = [],
    ): Observable<DownloadCSVUrl> {
        return this.api.getCellResultListCsv(request, paramsString, filters);
    }
}
